import { Select, type ComboboxData } from "@mantine/core";
import type { ProjectMinimal } from "../../utils/backend-types";

type AllProjects = {
  id: undefined;
  name: string;
};

interface ProjectSelectionProps {
  projectId?: string;
  projects: Array<ProjectMinimal | AllProjects>;
  onChange: (changedProjectId?: string) => void;
}

function ProjectSelection({
  projectId,
  projects,
  onChange
}: ProjectSelectionProps) {
  function handleChange(newProjectId: string | null) {
    const changedProjectId =
      newProjectId === "all-projects" || newProjectId === null
        ? undefined
        : newProjectId;
    onChange(changedProjectId);
  }

  const projectChoices: ComboboxData = projects
    ? projects.map((project) => ({
        value: project.id || "all-projects",
        label: project.name
      }))
    : [];
  const project: ProjectMinimal | AllProjects | undefined = projects?.find(
    (project) => project.id === projectId
  );

  return projects.filter((project) => project.id !== undefined).length > 1 ? (
    <Select
      aria-label="Projektauswahl"
      data={projects && projects.length > 1 ? projectChoices : []}
      placeholder="Projektauswahl"
      value={project?.id || "all-projects"}
      w={500}
      onChange={handleChange}
    />
  ) : null;
}

export { ProjectSelection, ProjectSelectionProps };
